import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center mt-2 space-x-3">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="p-2 border rounded-full disabled:opacity-40 hover:bg-gray-100"
      >
        <FaChevronLeft />
      </button>

      <span className="px-3 py-1 border rounded text-sm font-medium">
        {currentPage} / {totalPages}
      </span>

      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="p-2 border rounded-full disabled:opacity-40 hover:bg-gray-100"
      >
        <FaChevronRight />
      </button>
    </div>
  );
};
